import { render, staticRenderFns } from "./DynamicComponentViewer.vue?vue&type=template&id=7ed8c722&scoped=true"
import script from "./DynamicComponentViewer.vue?vue&type=script&lang=js"
export * from "./DynamicComponentViewer.vue?vue&type=script&lang=js"
import style0 from "./DynamicComponentViewer.vue?vue&type=style&index=0&id=7ed8c722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed8c722",
  null
  
)

export default component.exports